import React from 'react';
import styles from './Radio.module.css';

export function RadioGroup({ children, className, ...rest }) {
    return (
        <div role="radiogroup" className={`${styles.group} ${className || ''}`} {...rest}>
            {children}
        </div>
    );
}

export default function Radio({ label, className, disabled, ...rest }) {
    return (
        <label className={`${styles.option} ${disabled ? styles.disabled : ''} ${className || ''}`}>
            <input type="radio" className={styles.input} disabled={disabled} {...rest} />
            <span className={styles.label}>{label}</span>
        </label>
    );
}
